// angular
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'pwj-profile-layout',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './profile-layout.component.html',
  styleUrl: './profile-layout.component.scss',
})
export class ProfileLayoutComponent implements OnInit {
  // dependencies
  private readonly _router = inject(Router);

  constructor() {}

  ngOnInit(): void {
    // check if user open profile page then navigate to favorite tab
    if (this._router.url === '/profile') {
      this._router.navigate(['profile/favorites']);
    }
  }
}
